export const adminRolePayload = {
  role: 'Admin',
  permissions: [
    'EMPLOYEES:read',
    'EMPLOYEES:write',
    'EMPLOYEES:edit',
    'EMPLOYEES:delete',
    'SETTINGS:read',
    'SETTINGS:write',
    'SETTINGS:edit',
    'SETTINGS:delete',
    'ATTENDANCE:read',
    'ATTENDANCE:write',
    'ATTENDANCE:edit',
    'ATTENDANCE:delete',
    // 'LEAD_MANAGEMENT:read',
    // 'LEAD_MANAGEMENT:write',
    // 'LEAD_MANAGEMENT:edit',
    // 'LEAD_MANAGEMENT:delete',
    // 'PROJECT_MANAGEMENT:read',
    // 'PROJECT_MANAGEMENT:write',
    // 'PROJECT_MANAGEMENT:edit',
    // 'PROJECT_MANAGEMENT:delete',
    // 'TASKS:read',
    // 'TASKS:write',
    // 'TASKS:edit',
    // 'TASKS:delete',
    'COLLECTION_MANAGEMENT:read',
    'COLLECTION_MANAGEMENT:write',
    'COLLECTION_MANAGEMENT:edit',
    'COLLECTION_MANAGEMENT:delete',
    // 'SELLS:read',
    // 'SELLS:write',
    // 'SELLS:edit',
    // 'SELLS:delete',
    'CUSTOMERS:read',
    'CUSTOMERS:write',
    'CUSTOMERS:edit',
    'CUSTOMERS:delete',
    'NOTIFICATIONS:read',
    'NOTIFICATIONS:write',
    'NOTIFICATIONS:edit',
    'NOTIFICATIONS:delete',
    'ANALYTICS:read',
    'ANALYTICS:write',
    'ANALYTICS:edit',
    'ANALYTICS:delete'
  ],
  extraPrivileges: [
    'DATA_DIRECT_REPORTEES',
    'DATA_INDIRECT_REPORTEES',
    'DATA_SKIP_HIERARCHY',
    'ANALYTICS_ORGANISATION',
    'DIRECT_ANALYTICS',
    'WORKFORCE_ADMIN_ACCESS',
    'DISPLAY_IN_REPORTES_TO_LIST',
    'HANDOVER_WORK_TO_EMPLOYEE',
    'ADD_EDIT_OWN_CASES',
    'ADD_EDIT_REPORTEES_CASES'
  ],
  onBoardingProcess: {
    enabled: true,
    mandatory: false,
    formId: '',
    buttonText: ''
  },
  offBoardingProcess: {
    enabled: true,
    mandatory: false,
    formId: '',
    buttonText: ''
  }
}

export const useCasePayload = {
  collection_management: {
    typeOfLoan: {
      text: 'Type of Loan',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Type of Loan',
      formVisibility: false,
      tableVisibility: true
    },
    bucket: {
      text: 'Bucket',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Bucket',
      formVisibility: true,
      tableVisibility: true
    },
    productInfo: {
      text: 'Product Info',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Product Info',
      formVisibility: true,
      tableVisibility: true
    },
    principalOutstanding: {
      text: 'Principal Outstanding',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: 'POS',
      formVisibility: true,
      tableVisibility: true
    },
    emiAmount: {
      text: 'EMI Amount',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: 'EMI Amount',
      formVisibility: true,
      tableVisibility: true
    },
    tenure: {
      text: 'Tenure Number',
      required: false,
      visible: true,
      type: 'NUMBER',
      suffix: ['Weekly', 'Monthly', 'Yearly'],
      displayName: 'Tenure',
      formVisibility: false,
      tableVisibility: true
    },
    emiStartDate: {
      text: 'EMI Start Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    emiEndDate: {
      text: 'EMI End Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    nextEmiDate: {
      text: 'Next EMI Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    caseOutcomeStatus: {
      text: 'Case Outcome Status',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    currentStatus: {
      text: 'Current Status',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Status',
      formVisibility: true,
      tableVisibility: true
    }
  },
  loan_management: {
    typeOfLoan: {
      text: 'Type of Loan',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Loan Type',
      formVisibility: false,
      tableVisibility: false
    },
    loanAmountRequested: {
      text: 'Loan Amount Requested',
      required: false,
      visible: true,
      type: 'NUMBER',
      displayName: 'Amount Requested',
      formVisibility: false,
      tableVisibility: false
    },
    loanAmountSanctioned: {
      text: 'Loan Amount Sanctioned',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: 'Amount. Sanctioned',
      formVisibility: false,
      tableVisibility: false
    },
    typeOfInterest: {
      text: 'Type of Interest',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Interest Type',
      formVisibility: false,
      tableVisibility: false
    },
    interestRate: {
      text: 'Interest Rate',
      required: false,
      visible: true,
      type: 'NUMBER',
      displayName: 'Interest Rate',
      formVisibility: false,
      tableVisibility: false
    },
    tenure: {
      text: 'Tenure Number',
      required: true,
      visible: true,
      type: 'NUMBER',
      suffix: ['Weekly', 'Monthly', 'Yearly'],
      displayName: 'Tenure',
      formVisibility: false,
      tableVisibility: false
    },
    emiAmount: {
      text: 'EMI Amount',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: 'Emi Amount',
      formVisibility: false,
      tableVisibility: false
    },
    sanctionDate: {
      text: 'Sanction Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    emiStartDate: {
      text: 'EMI Start Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    emiEndDate: {
      text: 'EMI End Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    nextEmiDate: {
      text: 'Next EMI Date',
      required: false,
      visible: true,
      type: 'DATE',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    totalEmiPaid: {
      text: 'Total EMI Paid',
      required: false,
      visible: true,
      type: 'NUMBER',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    overdueAmount: {
      text: 'Overdue Amount',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    processingFee: {
      text: 'Processing Fee',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    latePaymentFee: {
      text: 'Late Payment Fee',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    prepaymentCharges: {
      text: 'Prepayment Charges',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    advisoryFee: {
      text: 'Advisory Fee',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    annualProcessingRate: {
      text: 'Annual Processing Rate',
      required: false,
      visible: true,
      type: 'NUMBER',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    debtServiceRatio: {
      text: 'Debt Service Ratio',
      required: false,
      visible: true,
      type: 'NUMBER',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    currentStatus: {
      text: 'Current Status',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    principalOutstanding: {
      text: 'Principal Outstanding',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    },
    totalAmountDisbursed: {
      text: 'Total Amount Disbursed',
      required: false,
      visible: true,
      type: 'NUMBER',
      prefix: ['₹', '$', '€', '£', '¥', '₽'],
      displayName: '',
      formVisibility: false,
      tableVisibility: false
    }
  }
}

export const extendUseCasePayload = {
  customerFieldMappings: {
    crn: {
      key: 'crn',
      displayName: 'CRN',
      visibility: true,
      formVisibility: false,
      tableVisibility: false
    },
    customerFullName: {
      key: 'name',
      displayName: 'Name',
      visibility: true,
      formVisibility: false,
      tableVisibility: false
    },
    customerMobile: {
      key: 'mobile',
      displayName: 'Mobile',
      visibility: true,
      formVisibility: false,
      tableVisibility: false
    },
    customerEmail: {
      key: 'email',
      displayName: 'Email',
      visibility: true,
      formVisibility: false,
      tableVisibility: false
    },
    addresses: [
      {
        typeOfAddress: 'CURRENT_ADDRESS',
        addressLine1: {
          key: 'address',
          displayName: 'Address'
        },
        addressLine2: {
          key: 'addressLine2',
          displayName: ''
        },
        landMark: {
          key: 'landMark',
          displayName: ''
        },
        city: {
          key: 'city',
          displayName: ''
        },
        state: {
          key: 'state',
          displayName: ''
        },
        country: {
          key: 'country',
          displayName: ''
        },
        pinCode: {
          key: 'pinCode',
          displayName: ''
        }
      }
    ],
    defaultAddress: 'CURRENT_ADDRESS',
    caseOutcomeStatus: {
      key: 'outcome',
      displayName: 'Outcome',
      visibility: true
    }
  },
  additionalColumns: {},
  tableTabMapping: {
    caseTable: {
      text: 'Cases',
      key: 'case',
      displayName: 'Case',
      icon: 'mdi-briefcase'
    },
    visitTable: {
      text: 'Visits',
      key: 'visit',
      displayName: 'Visit',
      icon: 'mdi-google-maps'
    },
    caseAnalyticsTable: {
      text: 'Case Analytics',
      key: 'case_analytics',
      displayName: 'Case Analytics',
      icon: 'mdi-chart-line'
    },
    callHistoryTable: {
      text: 'Call History',
      key: 'call_history',
      displayName: 'Call History',
      icon: 'mdi-phone-log'
    },
    customerTable: {
      text: 'Customers',
      key: 'customers',
      displayName: 'Customers',
      icon: 'mdi-account-multiple'
    }
  },
  entity: {
    displayName: 'Entity',
    key: 'entity',
    enabled: false
  },
  baseFieldMappings: {
    caseNo: {
      text: 'Case No',
      required: true,
      visible: true,
      type: 'STRING',
      displayName: 'Case No',
      key: 'case_no',
      formVisibility: true,
      tableVisibility: true
    },
    assignedTo: {
      text: 'Assigned To',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Assigned To',
      key: 'assigned_to',
      formVisibility: true,
      tableVisibility: true
    },
    taskTitle: {
      text: 'Task Title',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Task Title',
      key: 'task_title',
      formVisibility: true,
      tableVisibility: true
    },
    taskDescription: {
      text: 'Task Description',
      required: false,
      visible: true,
      type: 'STRING',
      displayName: 'Task Description',
      key: 'task_description',
      formVisibility: false,
      tableVisibility: true
    }
  },
  questionnaire: [],
  userFeedbackQuestionnaire: [],
  userDefinedCaseStatus: [
    {
      categoryName: 'Codes',
      options: ['PTP', 'RTP', 'PAID'],
      optionsList: [
        {
          code: 'PTP',
          amountVisibility: false,
          fields: []
        },
        {
          code: 'RTP',
          amountVisibility: false,
          fields: []
        },
        {
          code: 'PAID',
          amountVisibility: false,
          fields: []
        }
      ],
      assignedTemplates: {},
      caseOutcomeFormId: {},
      customerFormId: {}
    }
  ],
  dataCategories: []
}

export const attendanceSetupPayload = {
  shiftStartTime: null,
  shiftEndTime: null,
  allowSystemCalculation: false,
  fullDayThreshold: 75,
  halfDayThreshold: 40,
  overTimeThreshold: 22,
  autoCheckout: false,
  autoAttendanceMark: false,
  strictAttendance: false,
  workingDays: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'],
  workingHours: 8,
  allowCheckInAllTime: false,
  strictCheckout: false,
  allowCheckInFromAllDefinedLocation: false,
  clockInWithQrCode: false,
  clockOutWithQrCode: false,
  isCheckedInSelfie: false,
  isCheckedOutSelfie: false
}

export const taskSetupPayload = {
  taskCompletionStepsConfig: [
    { canSkip: false, step: 'SELFIE' },
    { canSkip: false, step: 'AUDIO_RECORDING' },
    { canSkip: false, step: 'MEETING_NOTES_WITH_ATTACHMENTS' }
  ],
  enableType: 'CUSTOM',
  isAutoReschedule: false,
  recurrenceTaskLimit: 15,
  allowTaskAutoEstimation: false,
  taskEstimationThreshold: null,
  allowTaskAcknowledgement: true,
  isTaskRecurrenceAllowedOrg: false,
  isTaskAutoAssignedAllowedOrg: false,
  isTaskDirectCompletionAllowedOrg: false,
  customerOTPVerification: false,
  isCollectionOtpRequired: false,
  allowedProofTypes: [],
  allowedMeetingOutcomesTypes: [],
  predefinedComplaintTitles: [],
  isTrackEmployeeActions: false,
  questionnaireDynamicForm: null
}

export const empAppSetupPayload = {
  appDashboardCustomization: {
    searchFilters: {
      bucket: {
        label: 'Bucket',
        visible: true
      },
      case: {
        label: 'Case',
        visible: true
      },
      customer: {
        label: 'Customer',
        visible: true
      }
    },
    mainFilter: 'sortBy',
    availableFilters: [
      {
        key: 'sortBy',
        label: 'Sort By',
        placeholder: 'created At',
        visible: true
      },
      {
        key: 'assignedTo',
        label: 'Assigned To',
        placeholder: 'Select Assigned To',
        visible: true
      },
      {
        key: 'subCase',
        label: 'Category',
        placeholder: 'Select Category',
        visible: true
      },
      {
        key: 'status',
        label: 'Status',
        placeholder: 'Select Status',
        visible: true
      },
      {
        key: 'outcome',
        label: 'Outcome',
        placeholder: 'Select Outcome',
        visible: true
      },
      {
        key: 'date',
        label: 'Select Date',
        placeholder: 'dd/mm/yyyy',
        visible: true
      },
      {
        key: 'entity',
        label: 'Entity',
        placeholder: 'Select Entity',
        visible: true
      }
    ]
  },
  orgRepo: {
    name: null,
    categories: [],
    enable: false,
    expansionState: false,
    openInNewTab: false,
    visibleInDashboard: false
  },
  stepperSteps: {
    caseType: {
      required: true,
      visibility: true,
      skip: false
    },
    addOrSelectCustomer: {
      required: true,
      visibility: true,
      skip: false
    },
    customerAddress: {
      required: true,
      visibility: true,
      skip: false
    },
    taskTitle: {
      required: true,
      visibility: true,
      skip: false,
      autogenerated: false,
      typeOfField: null
    },
    caseStartAndEndTime: {
      required: true,
      visibility: true,
      skip: false,
      autogenerated: false
    }
  },
  customActivitySteps: [],
  isCheckInAllowed: true,
  isClosingCaseAllowed: false,
  isTaskRecurrenceAllowed: false,
  isTaskCreationAllowed: true,
  isDirectVisitStartAllowed: false,
  clockInWithTimeline: false
}

export const adminDashboardSetupPayload = {
  adminDashboardCustomization: {
    employeeStats: true,
    progressStats: false,
    caseAnalyticsStats: false,
    visitAnalyticsStats: false,
    visitCollectionStats: false,
    teleCallingStats: false,
    loanStats: false,
    emiStats: false,
    recentEmis: false,
    emiActions: false
  }
}
